export const USER_SCORE_URL = '/r/loyalty/point/v1/';
